module.exports = __webpack_public_path__ + "img/Icon_registro_hover.b3148f62.svg";